import * as types from "../types";

export const init = {
  defaultCurrency: null,
  currentCurrency: null,
  items: [],
  loading: false,
  error: null,
};

export default function languages(state = {}, action) {
  switch (action.type) {
    case types.FETCH_CURRENCIES:
    case types.FETCH_DEFAULT_CURRENCY:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_CURRENCIES_FAILURE:
    case types.FETCH_DEFAULT_CURRENCY_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case types.FETCH_CURRENCIES_SUCCESS:
      return {
        ...state,
        items: [...action.data],
        loading: false,
      };

    case types.FETCH_DEFAULT_CURRENCY_SUCCESS:
    case types.SET_DEFAULT_CURRENCY:
      return {
        ...state,
        defaultCurrency: action.defaultCurrency,
        currentCurrency: action.defaultCurrency,
        loading: false,
      };

    default:
      return state;
  }
}
